import React from 'react';
import _ from 'lodash';

import FieldTemplate from '../field-template';
import SelectWidget from '../widgets/select-widget';

function ObjectSelectField(props) {
  const {
    name,
    required,
    formData,
    errorSchema,
    idSchema,
    schema,
    uiSchema,
    ...selectProps
  } = props;

  const id = idSchema.$id;

  const description =
    uiSchema["ui:description"] ||
    schema.description;

  const uiOptions = uiSchema['ui:options'];
  const enumOptions = uiOptions.enum.map((value, i) => {
    const label = (uiOptions.enumNames && uiOptions.enumNames[i]) || String(value);
    return { label, value };
  });
  const options = { enumOptions };

  return (
    <FieldTemplate
      required={required}
      displayLabel
      label={_.startCase(name)}
      description={description}>
      <div></div>
      <SelectWidget
        id={id}
        options={options}
        value={formData}
        schema={schema}
        {...selectProps} />
    </FieldTemplate>
  );
}

export default ObjectSelectField;



// WEBPACK FOOTER //
// ./src/components/ui/semantic-form/fields/object-select-field.js